import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAdminAuth } from '../auth/AdminAuthProvider'

export default function KakaoCallbackPage() {
  const { completeKakaoLogin } = useAdminAuth()
  const navigate = useNavigate()
  const [error, setError] = useState('')
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return undefined
    started.current = true
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const state = params.get('state')
    const kakaoError = params.get('error_description') || params.get('error')
    if (kakaoError || !code || !state) {
      setError(kakaoError || '카카오 로그인 코드를 찾을 수 없습니다.')
      return undefined
    }

    let active = true
    completeKakaoLogin(code, state)
      .then(() => { if (active) navigate('/dashboard', { replace: true }) })
      .catch(err => { if (active) setError(err?.message || '카카오 로그인 처리 중 오류가 발생했습니다.') })
    return () => { active = false }
  }, [completeKakaoLogin, navigate])

  return (
    <main className="access-state">
      <p className="eyebrow">SU-GUIDE ADMIN</p>
      <h1>{error ? '로그인에 실패했습니다' : '카카오 계정을 확인하고 있습니다'}</h1>
      <p>{error || 'Firebase 관리자 권한을 안전하게 확인하는 중입니다.'}</p>
      {error && <button className="button secondary" type="button" onClick={() => navigate('/login', { replace: true })}>로그인으로 돌아가기</button>}
    </main>
  )
}
